export const APIENDPOINT = '/api/v1/';
